import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {Subject} from 'rxjs';


export enum IdleUserTimes {
    IdleTime = 3000,
    CountdownTime = 5000
}

@Injectable({
    providedIn: 'root'
})
export class IdleUserDetectionService {
    private timeoutId: NodeJS.Timeout;
    private countdownId:NodeJS.Timeout;
    private countdownValue: number;

    private detectionEventsList = ['mousemove', 'click', 'keypress', 'DOMMouseScroll', 'mousewheel', 'touchmove', 'MSPointerMove'];
    private listenersList: (() => void)[] = [];
    private renderer:Renderer2;

    userInactive: Subject<boolean> = new Subject();


    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }


    startDetection() {
        this.detectionEventsList.forEach(event => {
            this.listenersList.push(this.renderer.listen(
                window,
                event,
                () => this.reset()
            ));
        });
    }

    stopDetections() {
        this.listenersList.forEach(listenerFn => listenerFn());
        this.stopIdleTimer();
        this.stopCountdown();
    }

    private reset() {
        clearTimeout(this.timeoutId);
        clearTimeout(this.countdownId);
        this.startIdleTimer();
        this.userInactive.next(false);
    }

    private startIdleTimer() {
        this.timeoutId = setTimeout(() => {
            this.startCountdown();
        }, IdleUserTimes.IdleTime);
    }

    private stopIdleTimer() {
        clearTimeout(this.timeoutId);
    }

    private startCountdown() {
        this.countdownValue = IdleUserTimes.CountdownTime / 1000;
        this.countdownId = setInterval(() => {
            this.countdownValue--;
            if (this.countdownValue <= 0) {
                clearInterval(this.countdownId);
                this.userInactive.next(true);
            }
        }, 1000);
    }

    private stopCountdown() {
        clearInterval(this.countdownId)
    }
}
